import { z } from 'zod';
import { isValidCpfOrCnpj } from '../utils/index.js';

export const recoverAppointmentSchema = z.object({
  customerEmail: z
    .string({ error: 'Email é obrigatório' })
    .email('Email inválido'),
  customerCpf: z
    .string({ error: 'CPF/CNPJ é obrigatório' })
    .regex(
      /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/,
      'CPF/CNPJ inválido (ex: 000.000.000-00 ou 00.000.000/0000-00)'
    )
    .refine(isValidCpfOrCnpj, 'CPF/CNPJ inválido'),
});

export type RecoverAppointmentFormData = z.infer<typeof recoverAppointmentSchema>;
